module.exports = __webpack_public_path__ + "img/ZohoCRM.a22f1065.svg";